import {
  initializeGravatar,
  initializeConditionallyShownContent,
} from './initializers';

function initializeShared() {
  initializeGravatar();
  initializeConditionallyShownContent();
}

export default initializeShared;
